import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import '../../forecast/styles/styles.css';
import {
  MotifTable,
  MotifTableCellRenderer,
  MotifIcon,
  MotifTooltip,
  MotifTextLink,
  MotifButton,
  MotifTruncate,
} from '@ey-xd/motif-react';
import { actionIcInfo24px } from '@ey-xd/motif-react/assets/icons';

import {
  EmptyForcastContainer,
  EmptyForcastText,
  CellWarningError,
  TableData1A,
  TableData1B,
  TableData1C,
  PLTableContainer,
  OppsListContainer,
  OppsContainer,
  OppsItemContainer,
  ToggleContainer,
  ItemTextContainer,
  ItemTovValueContainer,
  ItemLinkText,
  ItemDetailsText,
  DateContainer,
  DateWarningContainer,
  AwdDateMainContainer,
  WarningIconContainer,
} from '../../../../atoms/tableData/styles/tableData.styles';
import PursuitLeaderToggle from './pursuitLeaderToggle';
import {
  getOpportunitiesDetails,
  getQuaterlyDetails,
  submitopportunityV2,
} from '../../../../../services/pursuitLeaderServices';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  PL_Commit_State,
  Pl_Opps_Details_Modal_State,
  Pl_Comment_Modal_State,
  Quaterly_OP_Details_State,
  Recoil_Quarter_State,
  Current_User,
  Pl_Submit_Success_Modal_State,
  Pl_Failure_Modal_State,
  PursuitLeaderTableRowDataState,
  System_Date_Time_State,
  Operating_System_State,
  Trigger_Update_Pl_Sidebar_Data,
  Pl_Sidebar_Update_Opp_Payload,
  Refresh_Pl_Sidebar_Data,
} from '../../../../../recoil/recoil';
import {
  convertDateToTimeStamp2,
  formatDateToYYYYMMDD,
  formatNumberWithKAndM,
  dateFormat,
  trimAndAddDots,
  formatAWDDate,
} from '../../../../../util/commonUtil';
import PlOpportunityNameModal from '../../../../organisms/modals/plOpportunityNameModal';
import TableHeader from '../../../../molecules/dcsp/components/tableHeader';
import SpinnerLoader from '../../../../atoms/SpinnerLoader';
import PlCommentModal from '../../../../organisms/modals/plCommentModal';
import {
  DateSorting,
  OppsNameSorting,
  DateFiltering,
  filterOpportunityById,
  QuarterYearSorting,
  retainCommitAndModifyOpportunity,
  QuaterlyDetailsChangeKeys,
  clientAccountNameSorting,
} from '../../../../../util/commonFunctions';
import { isMobile, isTablet } from 'react-device-detect';
import chat_outline from '../../../../assets/icons/chat_outline.png';
import { OPERATING_SYSTEM, TABLE_HEADER_SUBTEXT } from '../../../../../constants/commonConstants';

let gridApi;
let PlOppsIframeUrl;
let CommentIframeUrl;
let PlMobileOppsIframeUrl;
let MobileCommentIframeUrl;
const screenWidth = window.innerWidth;

const PursuitLeaderTable = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [totalPageRows, setTotalPageRows] = useState(null);
  const [rowData, setRowData] = useRecoilState(PursuitLeaderTableRowDataState);

  const [plCommitData, setPlCommitData] = useRecoilState(PL_Commit_State);
  const [plQuaterlyDetails, setPlQuaterlyDetails] = useRecoilState(Quaterly_OP_Details_State);
  const [quarterData, setQuarterData] = useRecoilState(Recoil_Quarter_State);
  const [opportunitiesLoaded, setOpportunitiesLoaded] = useState(false);

  const [showPlIframeModalRecoil, setPlIframeModalRecoil] = useRecoilState(
    Pl_Opps_Details_Modal_State,
  );

  const [showSubmitConfirmationModal, setShowSubmitConfirmationModal] = useRecoilState(
    Pl_Submit_Success_Modal_State,
  );

  const [showFailureSubmitModal, setShowFailureSubmitModal] =
    useRecoilState(Pl_Failure_Modal_State);

  const [showCommentIframeModalRecoil, setCommentIframeModalRecoil] =
    useRecoilState(Pl_Comment_Modal_State);

  const [triggerUpdatePlSidebarData, setTriggerUpdatePlSidebarData] = useRecoilState(
    Trigger_Update_Pl_Sidebar_Data,
  );

  const [commitStatusUpdateOpportunity, setCommitStatusUpdateOpportunity] = useRecoilState(
    Pl_Sidebar_Update_Opp_Payload,
  );

  const [showEmptyForecast, setShowEmptyForecast] = useState(false);
  const currentUser = useRecoilValue(Current_User);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const osInfo = useRecoilValue(Operating_System_State);
  const [refreshPLSidebarData, setRefreshPLSidebarData] = useRecoilState(Refresh_Pl_Sidebar_Data);

  let rowDataArray;

  useEffect(() => {
    if (quarterData !== null) {
      const fetchData = async () => {
        setIsLoading(true);
        try {
          let getOpportunitiesDetailsAPI = await getOpportunitiesDetails(currentUser.email);
          rowDataArray = getOpportunitiesDetailsAPI.opportunities;

          if (!!sessionStorage.getItem('rowData')) {
            setTimeout(async () => {
              const oldRowDataArray = JSON.parse(sessionStorage.getItem('rowData'));
              const getOpportunitiesDetailsAPI = await getOpportunitiesDetails(currentUser.email);
              const newOpportunites = getOpportunitiesDetailsAPI.opportunities;
              sessionStorage.setItem('CrmUpdatedOpportunities', JSON.stringify(newOpportunites));

              const updateOpportunites = await retainCommitAndModifyOpportunity(
                oldRowDataArray,
                newOpportunites,
              );
              // sessionStorage.setItem('rowData', JSON.stringify(updateOpportunites));
              setRowData(updateOpportunites);
              setRefreshPLSidebarData(!refreshPLSidebarData);
            }, 3000);
          } else {
            sessionStorage.setItem('CrmUpdatedOpportunities', JSON.stringify(rowDataArray));
            setRowData(getOpportunitiesDetailsAPI.opportunities);
            sessionStorage.setItem(
              'rowData',
              JSON.stringify(getOpportunitiesDetailsAPI.opportunities),
            );
            setRefreshPLSidebarData(!refreshPLSidebarData);
          }

          let newPlQuaterlyDetails = await getCrmQuaterlyOpportunities(rowDataArray);
          setPlQuaterlyDetails(newPlQuaterlyDetails);
          //To be Removed
          //   const QUATER_START_DATE = quarterData
          //   ? formatDateToYYYYMMDD(quarterData.quarter_start_date)
          //   : '';
          // const QUATER_END_DATE = quarterData
          //   ? formatDateToYYYYMMDD(quarterData.quarter_end_date)
          //   : '';

          // let getQuaterlyDetailsAPI = await getQuaterlyDetails(
          //   currentUser.email,
          //   QUATER_START_DATE,
          //   QUATER_END_DATE,
          // );

          setTimeout(() => {
            const availableTableHeight = document.getElementById('container')?.clientHeight;
            const rowCount = availableTableHeight && calculatePageSize(availableTableHeight);
            setTotalPageRows(rowCount);
          }, 500);
        } catch (error) {
          console.error('Error:', error);
        } finally {
          const timeoutId = setTimeout(() => {
            setIsLoading(false);
          }, 2000);
          return () => clearTimeout(timeoutId);
        }
      };
      fetchData();
    }
  }, [quarterData]);

  useEffect(async () => {
    if (
      !!sessionStorage.getItem('CrmUpdatedOpportunities') &&
      rowData !== 0 &&
      quarterData !== null
    ) {
      let updatedCommitStatusList = rowData;
      let NonUpdatedCommitStatusList = JSON.parse(
        sessionStorage.getItem('CrmUpdatedOpportunities'),
      );
      let newPlQuaterlyDetails = await getCrmQuaterlyOpportunities(updatedCommitStatusList);
      setPlQuaterlyDetails(newPlQuaterlyDetails);
      const crm_quaterly_response = await QuaterlyDetailsChangeKeys(newPlQuaterlyDetails);

      sessionStorage.setItem('rowData', JSON.stringify(updatedCommitStatusList));

      updatedCommitStatusList.forEach(newObj => {
        const oldObj = NonUpdatedCommitStatusList.find(oldObj => oldObj.opp_id === newObj.opp_id);

        if (oldObj && oldObj.commit_status !== newObj.commit_status) {
          setToggleChange(newObj.commit_status, newObj.opportunity_id, crm_quaterly_response);

          // To send modified opportunity details to update sidebar
          let opportunityUpdatePayload = {
            toggleStatus: newObj.commit_status,
            opp_id: newObj.opp_id,
            tov: newObj.tov,
            awd: newObj.awd,
            awd_period: newObj.awd_period,
            fiscal_year: newObj.fiscal_year,
            month: newObj.month,
          };

          setCommitStatusUpdateOpportunity(opportunityUpdatePayload);
        }
      });

      sessionStorage.removeItem('CrmUpdatedOpportunities');
    }
  }, [triggerUpdatePlSidebarData]);

  useEffect(() => {
    // Added this to re-update recoil to get fresh data for next use.
    const savedRowData = sessionStorage.getItem('rowData');
    if (savedRowData) {
      setRowData(JSON.parse(savedRowData));
    }
  }, [plCommitData]);

  const getCrmQuaterlyOpportunities = async rowOpportunityData => {
    const QUATER_START_DATE = quarterData
      ? formatDateToYYYYMMDD(quarterData.quarter_start_date)
      : '';
    const QUATER_END_DATE = quarterData ? formatDateToYYYYMMDD(quarterData.quarter_end_date) : '';

    let getQuaterlyDetailsAPI = await getQuaterlyDetails(
      currentUser.email,
      QUATER_START_DATE,
      QUATER_END_DATE,
    );

    let newPlQuaterlyDetails = await filterOpportunityById(
      getQuaterlyDetailsAPI.CRM_Response,
      rowOpportunityData,
    );
    // setPlQuaterlyDetails(newPlQuaterlyDetails);
    return newPlQuaterlyDetails;
  };

  const calculatePageSize = tableHeight => {
    const screenHeight = window.innerHeight;
    const singleRowHeight = 43; //(in Pixel)
    let noOfRowsToBeRemoved = osInfo == OPERATING_SYSTEM.MAC ? 1 : 2;
    let minusFactor = screenHeight <= 720 ? noOfRowsToBeRemoved : noOfRowsToBeRemoved + 1;
    const totalRows = Math.floor(tableHeight / singleRowHeight) - minusFactor;
    return JSON.stringify(totalRows);
  };

  const handleGridReady = params => {
    ({ api: gridApi } = params);
  };

  const TextCellRendererA = ({ value }) => <TableData1A>{value}</TableData1A>;
  TextCellRendererA.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const TextCellRendererB = ({ value }) => <TableData1B>{value}</TableData1B>;
  TextCellRendererB.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const TextCellRendererC = ({ value }) => (
    <TableData1C>
      <MotifTooltip
        id="bottom"
        trigger={trimAndAddDots(value)}
        allowHover={true}
        allowClick={true}
        placement="bottom"
      >
        {value}
      </MotifTooltip>
    </TableData1C>
  );
  TextCellRendererB.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const TextCellRendererE = ({ value }) => (
    <TableData1C>
      <MotifTruncate maxWidth={140}>{value}</MotifTruncate>
    </TableData1C>
  );
  TextCellRendererE.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const TextCellRendererD = ({ value }) => {
    // For addign '$' Sign to TOV value
    let formattedValue = Number(value).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return <TableData1C>{formattedValue}</TableData1C>;
  };
  TextCellRendererD.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const AWD_Field_Rendere = props => {
    let { awd, month, quarterDataObj } = props;

    let awdTimeStamp = awd;
    let MonthStartDateCheck = quarterData
      ? new Date(quarterData.current_month_start_date)
      : new Date(systemDateTime);
    awdTimeStamp = new Date(awdTimeStamp);
    awdTimeStamp = new Date(
      awdTimeStamp.getFullYear(),
      awdTimeStamp.getMonth(),
      awdTimeStamp.getDate(),
    );
    MonthStartDateCheck = new Date(MonthStartDateCheck.toISOString().split('T')[0]);

    MonthStartDateCheck = new Date(
      MonthStartDateCheck.getFullYear(),
      MonthStartDateCheck.getMonth(),
      MonthStartDateCheck.getDate(),
    );

    if (awdTimeStamp < MonthStartDateCheck) {
      return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <MotifTooltip
            id="bottom"
            trigger={<MotifIcon src={actionIcInfo24px} className="CellWarningError" />}
            allowHover={true}
            allowClick={true}
            placement="bottom"
          >
            This AWD is in the past. You’ll <br /> need to update the AWD in the <br /> Opportunity
            before changing <br /> the commit status.
          </MotifTooltip>

          <CellWarningError>{`${formatAWDDate(awd)} (${month})`}</CellWarningError>
        </div>
      );
    }
    return <TableData1C>{`${formatAWDDate(awd)} (${month})`}</TableData1C>;
  };
  AWD_Field_Rendere.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const TextLinkRenderer = props => {
    const { value, opportunity_id } = props;

    return (
      <div style={{ alignSelf: 'center', display: 'flex', alignItems: 'center' }}>
        <TableData1A>
          <MotifTextLink
            variant="alt"
            href="#"
            onClick={() => {
              onOpportunityNameClick(opportunity_id);
            }}
            // style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',  }}
          >
            <MotifTooltip
              id="bottom"
              trigger={trimAndAddDots(value)}
              allowHover={true}
              allowClick={true}
              placement="bottom"
            >
              {value}
            </MotifTooltip>
          </MotifTextLink>
        </TableData1A>
      </div>
    );
  };
  // );
  TextLinkRenderer.propTypes = {
    value: PropTypes.string.isRequired,
  };

  let crm_update = [];

  const setToggleChange = (commit_status, opportunity_id, crm_quaterly_response) => {
    let predata = rowData.map(item => ({
      commit_status: item.commit_status,
      opportunity_id: item.opportunity_id,
    }));

    predata = predata.filter(
      item => item.opportunity_id == opportunity_id && item.commit_status == commit_status,
    );

    if (opportunity_id) {
      let crm_obj = {
        commit_status: commit_status,
        opportunity_id: opportunity_id,
      };

      crm_update = crm_update.filter(item => item.opportunity_id !== opportunity_id);

      if (predata.length == 0) {
        crm_update.push(crm_obj);
      }

      // Added for commit retain functionality
      if (predata.length !== 0 && !!sessionStorage.getItem('CrmUpdatedOpportunities')) {
        crm_update.push(crm_obj);
      }

      setPlCommitData({
        forecast_table_details: {
          forecast_id: currentUser.email,
        },
        crm_update: [...crm_update],
        crm_quaterly_response: crm_quaterly_response,
      });
    } else if (crm_update.length != 0 && opportunity_id) {
      // If commit_status is false, removing the obj based on opportunity_id
      crm_update = crm_update.filter(item => item.opportunity_id !== opportunity_id);

      setPlCommitData({
        forecast_table_details: {
          forecast_id: currentUser.email,
        },
        crm_update: [...crm_update],
        crm_quaterly_response: crm_quaterly_response,
      });
    }

    modifyOpportunityDetails(commit_status, opportunity_id);
  };

  const modifyOpportunityDetails = (commit_status, opportunity_id) => {
    const savedRowData = sessionStorage.getItem('rowData');
    let updatedRowData = JSON.parse(savedRowData).map(item => {
      if (item.opp_id === opportunity_id) {
        return { ...item, commit_status: commit_status };
      }
      return item;
    });
    sessionStorage.setItem('rowData', JSON.stringify(updatedRowData));
    setRowData(updatedRowData);
  };

  const ToggleSwicthRenderer = props => {
    const {
      value,
      opportunity_id,
      tov,
      awd,
      awd_period,
      month,
      fiscal_year,
      quarterDataObj,
      commit_status,
    } = props;

    let isDisabled = false;
    let awdTimeStamp = awd;
    let MonthStartDateCheck = quarterData
      ? new Date(quarterData.current_month_start_date)
      : new Date(systemDateTime);
    awdTimeStamp = new Date(awdTimeStamp);
    awdTimeStamp = new Date(
      awdTimeStamp.getFullYear(),
      awdTimeStamp.getMonth(),
      awdTimeStamp.getDate(),
    );
    MonthStartDateCheck = new Date(MonthStartDateCheck.toISOString().split('T')[0]);
    MonthStartDateCheck = new Date(
      MonthStartDateCheck.getFullYear(),
      MonthStartDateCheck.getMonth(),
      MonthStartDateCheck.getDate(),
    );

    if (awdTimeStamp < MonthStartDateCheck) {
      isDisabled = true;
    }

    return (
      <PursuitLeaderToggle
        toggleStatus={((isMobile || isTablet) && screenWidth < 1170)? commit_status: value}
        opp_id={opportunity_id}
        tov={tov}
        awd={awd}
        awd_period={awd_period}
        month={month}
        fiscal_year={fiscal_year}
        onToggleChange={(commit_status, crm_quaterly_response) => {
          setToggleChange(commit_status, opportunity_id, crm_quaterly_response);
        }}
        isDisabled={isDisabled}
      />
    );
  };
  ToggleSwicthRenderer.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const handleCommitLink = opp_id => {
    onCommentIconClick(opp_id);
  };

  const CommentColumnRenderer = ({ value, data }) => (
    <div style={{ alignSelf: 'center', display: 'flex', alignItems: 'center' }}>
      <TableData1A>
        <MotifTextLink variant="alt" href="#" onClick={() => handleCommitLink(data.opp_id)}>
          {value}
          <span style={{ margin: '3px' }}> </span>
          <img src={chat_outline} alt="Comment link" className="CustomChatIcon" />
        </MotifTextLink>
      </TableData1A>
    </div>
  );

  const rowClassRules = useMemo(() => {
    return {
      'toggle-checked-row': params => params.data.commit_status == true,
    };
  }, []);

  const columnDefs = [
    {
      headerName: 'Commit',
      cellRenderer: 'motifTableCellRenderer',
      field: 'commit_status',
      cellRenderer: 'toggleSwicthRenderer',
      cellRendererParams: params => {
        const opportunity_id = params.data.opportunity_id;
        const tov = params.data.tov;
        const awd = params.data.awd;
        const awd_period = params.data.fiscal_quarter;
        const month = params.data.fiscal_month;
        const fiscal_year = params.data.fiscal_year;
        const quarterDataObj = quarterData;
        return {
          opportunity_id,
          tov,
          awd,
          awd_period,
          month,
          fiscal_year,
          quarterDataObj,
        };
      },
      width: 125,
      pinned: 'left',
      suppressMovable: true,
    },
    {
      headerName: 'ID',
      field: 'ey_id',
      sortable: true,
      filter: true,
      cellRenderer: 'textCellRendererE',
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 95,
      suppressMovable: true,
    },
    {
      headerName: 'Opportunity Name',
      field: 'opportunity_name',
      sortable: true,
      filter: true,
      cellRenderer: 'textLinkRenderer', //opportunity_name
      cellRendererParams: params => {
        const opportunity_id = params.data.opportunity_id;
        return { opportunity_id };
      },

      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 200,
      comparator: OppsNameSorting,
      suppressMovable: true,
    },
    {
      headerName: 'Client',
      field: 'client_name',
      sortable: true,
      filter: true,
      cellRenderer: 'textCellRendererC',
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 200,
      suppressMovable: true,
      comparator: clientAccountNameSorting,
    },
    {
      headerName: 'AWD',
      field: 'awd',
      sortable: false,
      filter: 'agDateColumnFilter',
      filterParams: DateFiltering,
      cellRenderer: 'awd_Field_Rendere',
      cellRendererParams: params => {
        const awd = params.data.awd;
        const month = params.data.fiscal_month;
        const quarterDataObj = quarterData;
        return {
          awd,
          month, //fiscal_month
          quarterDataObj,
        };
      },
      headerComponentParams: {
        showFilter: true,
        enableSorting: true,
        subText: TABLE_HEADER_SUBTEXT.DATE_FISCAL_MONTH,
      },
      width: 175,
      comparator: DateSorting,
      suppressMovable: true,
    },

    {
      headerName: 'TOV ($)',
      field: 'tov',
      sortable: true,
      filter: true,
      cellRenderer: 'textCellRendererD',
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 140,
      cellClass: 'cell-text-aligment',
      suppressMovable: true,
    },
    {
      headerName: 'Quarter',
      field: 'quarter_year',
      sortable: false,
      filter: true,
      comparator: QuarterYearSorting,
      cellRenderer: 'textCellRendererE',
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 130,
      cellClass: 'cell-text-aligment',
      suppressMovable: true,
    },
    {
      headerName: 'Stage',
      field: 'stagecode_name',
      sortable: true,
      filter: true,
      cellRenderer: 'textCellRendererE',
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 130,
      suppressMovable: true,
    },
    {
      headerName: 'Prob(%)',
      field: 'close_probablity',
      sortable: true,
      filter: true,
      cellRenderer: 'textCellRendererE',
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 130,
      cellClass: 'cell-text-aligment',
      suppressMovable: true,
    },
    {
      headerName: 'Account',
      field: 'account_name',
      sortable: true,
      filter: true,
      cellRenderer: 'textCellRendererC',
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 200,
      suppressMovable: true,
      comparator: clientAccountNameSorting,
    },
    {
      headerName: 'Comment',
      field: 'comment',
      cellRenderer: 'commentColumnRenderer',
      width: 100,
      suppressMovable: true,
    },
  ];

  const onOpportunityNameClick = id => {
    PlOppsIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_OPP_NAME_URL_FORM_ID}`;
    PlMobileOppsIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_MOBILE_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_OPP_NAME_URL_FORM_ID}`;
    setPlIframeModalRecoil(true);
  };

  const onCommentIconClick = id => {
    CommentIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_COMMENT_URL_FORM_ID}`;
    MobileCommentIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_MOBILE_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_COMMENT_URL_FORM_ID}`;
    setCommentIframeModalRecoil(true);
  };

  const handleEmptyForecastSubmit = async () => {
    if (!quarterData) {
      return;
    }

    const MONTH = quarterData.month;
    const YEAR = quarterData.fiscal_year;
    const QUARTER = quarterData.quarter;

    const snapDates = {
      fiscal_month_startdate: quarterData?.current_month_start_date,
      fiscal_month_enddate: quarterData?.current_month_end_date,
      fiscal_quarter_startdate: quarterData?.quarter_start_date,
      fiscal_quarter_enddate: quarterData?.quarter_end_date,
    };

    const rollingDates = {
      fiscal_month_startdate: quarterData?.quarter_start_date,
      fiscal_month_enddate: quarterData?.quarter_end_date,
    };

    const REQ_BODY = {
      forecast_table_details: {
        forecast_id: currentUser.email,
      },
      crm_update: [],
      crm_quaterly_response: [],
      snap_dates: snapDates,
      rolling_dates: rollingDates,
      crm_full_res: [],
    };

    JSON.stringify(REQ_BODY);

    try {
      const response = await submitopportunityV2(MONTH, YEAR, QUARTER, REQ_BODY, currentUser.email);
      if (response === true) {
        setShowSubmitConfirmationModal(true);
      }
      setPlCommitData({});
    } catch (error) {
      setShowFailureSubmitModal(true);
    }
  };

  return (
    <>
      <PLTableContainer id="container">
        {!isMobile && (
          <>
            {isLoading && !opportunitiesLoaded ? (
              <div
                style={
                  isMobile
                    ? { position: 'fixed', top: '50%', left: '50%' }
                    : { position: 'fixed', top: '50%', left: '35%' }
                }
              >
                <SpinnerLoader color="#155CB4" />
              </div>
            ) : (
              <>
                {rowData.length === 0 ? (
                  <EmptyForcastContainer>
                    <EmptyForcastText>
                      There are currently no open opportunities with you named as Pursuit Leader.
                    </EmptyForcastText>
                    <MotifButton
                      style={{ width: '220px', height: '36px' }}
                      onClick={handleEmptyForecastSubmit}
                    >
                      Submit Empty Forecast
                    </MotifButton>
                  </EmptyForcastContainer>
                ) : (
                  <MotifTable
                    // title="Title Bar"
                    //  domLayout="autoHeight"
                    firstColumnBorderRight
                    columnDefs={columnDefs}
                    rowData={rowData}
                    rowSelection="multiple"
                    onGridReady={handleGridReady}
                    suppressRowClickSelection
                    suppressCellFocus
                    suppressRowHoverHighlight={true}
                    columnHoverHighlight={true}
                    rowClassRules={rowClassRules}
                    onSortChanged={() => gridApi.redrawRows()}
                    components={{
                      agColumnHeader: TableHeader, //for subtext add molecules/dcsp/components/tableHeader.jsx
                      motifTableCellRenderer: MotifTableCellRenderer,
                      textCellRendererA: TextCellRendererA,
                      textCellRendererB: TextCellRendererB,
                      textCellRendererC: TextCellRendererC,
                      textCellRendererD: TextCellRendererD,
                      textCellRendererE: TextCellRendererE,
                      textLinkRenderer: TextLinkRenderer,
                      toggleSwicthRenderer: ToggleSwicthRenderer,
                      commentColumnRenderer: CommentColumnRenderer,
                      awd_Field_Rendere: AWD_Field_Rendere,
                    }}
                    alwaysShowHorizontalScroll={true}
                    //  Pagination
                    paginationPageSize={totalPageRows}
                    pagination={true}
                  />
                )}
              </>
            )}
          </>
        )}

        {showPlIframeModalRecoil && (
          <PlOpportunityNameModal urlSource={isMobile ? PlMobileOppsIframeUrl : PlOppsIframeUrl} />
        )}

        {showCommentIframeModalRecoil && (
          <PlCommentModal urlSource={isMobile ? MobileCommentIframeUrl : CommentIframeUrl} />
        )}

        {isMobile && (
          <>
            {isLoading && !opportunitiesLoaded ? (
              <div
                style={
                  isMobile
                    ? { position: 'fixed', top: '50%', left: '50%' }
                    : { position: 'fixed', top: '50%', left: '35%' }
                }
              >
                <SpinnerLoader color="#155CB4" />
              </div>
            ) : (
              <>
                {rowData.length === 0 ? (
                  <EmptyForcastContainer>
                    <EmptyForcastText>
                      There are currently no open opportunities with you named as Pursuit Leader.
                    </EmptyForcastText>
                    <MotifButton
                      style={{ width: '220px', height: '36px' }}
                      onClick={handleEmptyForecastSubmit}
                    >
                      Submit Empty Forecast
                    </MotifButton>
                  </EmptyForcastContainer>
                ) : (
                  <OppsContainer>
                    <OppsListContainer>
                      {rowData.map(item => (
                        <OppsItemContainer key={item.opp_id}>
                          <ToggleContainer>{ToggleSwicthRenderer(item)}</ToggleContainer>
                          <ItemTextContainer>
                            <ItemLinkText
                              onClick={() => {
                                onOpportunityNameClick(item.opportunity_id);
                              }}
                            >
                              {item.opportunity_name
                                ? trimAndAddDots(item.opportunity_name, 68) //68 is length of how much chars will shows
                                : item.opportunity_name}
                            </ItemLinkText>
                            <ItemDetailsText>
                              {item.client_name
                                ? trimAndAddDots(item.client_name, 35) //35 is length of how much chars will shows
                                : item.client_name}
                            </ItemDetailsText>
                            <ItemDetailsText>
                              <> {item.stagecode_name} | </>
                              <>
                                {new Date(item.awd) < new Date(systemDateTime) ? (
                                  <AwdDateMainContainer>
                                    <MotifTooltip
                                      id="bottom"
                                      style={{ position: 'absolute' }}
                                      trigger={
                                        <WarningIconContainer
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <MotifIcon
                                            src={actionIcInfo24px}
                                            className="CellWarningErrorMobile"
                                          />
                                          <DateWarningContainer>
                                            {dateFormat(convertDateToTimeStamp2(item.awd))}
                                          </DateWarningContainer>
                                        </WarningIconContainer>
                                      }
                                      allowHover={true}
                                      allowClick={true}
                                      placement="bottom"
                                    >
                                      This AWD is in the past. You’ll need to update the AWD in the
                                      Opportunity before changing the commit status.
                                    </MotifTooltip>
                                  </AwdDateMainContainer>
                                ) : (
                                  <DateContainer>
                                    {dateFormat(convertDateToTimeStamp2(item.awd))}
                                  </DateContainer>
                                )}
                              </>
                              <> | {item.quarter_year}</>
                            </ItemDetailsText>
                          </ItemTextContainer>
                          <ItemTovValueContainer>
                            {formatNumberWithKAndM(item.tov)}
                          </ItemTovValueContainer>
                        </OppsItemContainer>
                      ))}
                    </OppsListContainer>
                  </OppsContainer>
                )}
              </>
            )}
          </>
        )}
      </PLTableContainer>
    </>
  );
};
export default PursuitLeaderTable;
